(() => {
  const btn = document.querySelector(".js-asmc-tv__mobile-moreBtn");
  const videoContainer = document.querySelector(".js-asmc-tv__videos");
  const fadeOut = document.querySelector(".js-asmc-tv__mobile-fadout");
  const lessBtn = document.querySelector(".js-asmc-tv__mobile-lessBtn");

  btn.addEventListener("click", () => {
    toggleClasses();
    videoContainer.style.maxHeight = videoContainer.scrollHeight + "px";
  });

  lessBtn.addEventListener("click", () => {
    toggleClasses();
    videoContainer.style.maxHeight = "400px";
  });

  function toggleClasses() {
    btn.classList.toggle("js-asmc-tv__pointer-events");
    btn.classList.toggle("js-asmc-tv__opacity0");
    fadeOut.classList.toggle("js-asmc-tv__opacity0");
  }
})();
